import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=439c0bfa&scoped=true&"
import script from "./ShopItem.vue?vue&type=script&lang=js&"
export * from "./ShopItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShopItem.vue?vue&type=style&index=1&id=439c0bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439c0bfa",
  null
  
)

export default component.exports